import React from 'react';

const Services = () => {
  const styles = {
    container: {
      backgroundColor: '#ffffff',
      color: '#333333',
      minHeight: '100vh',
      padding: '4rem 2rem',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      lineHeight: '1.6'
    },
    content: {
      maxWidth: '900px',
      margin: '0 auto',
    },
    header: {
      textAlign: 'center',
      marginBottom: '3rem',
      borderBottom: '2px solid #000000',
      paddingBottom: '1.5rem'
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: '#000000',
      marginBottom: '0.5rem'
    },
    subtitle: {
      fontSize: '1.2rem',
      color: '#555555',
      fontWeight: '300'
    },
    servicesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
      gap: '2rem',
      marginTop: '2rem'
    },
    serviceCard: {
      border: '1px solid #eeeeee',
      borderRadius: '8px',
      padding: '2rem',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      ':hover': {
        transform: 'translateY(-5px)',
        boxShadow: '0 10px 20px rgba(0,0,0,0.1)'
      }
    },
    serviceIcon: {
      fontSize: '2.5rem',
      marginBottom: '1.5rem',
      color: '#000000'
    },
    serviceTitle: {
      fontSize: '1.5rem',
      fontWeight: '600',
      marginBottom: '1rem',
      color: '#000000'
    },
    serviceDescription: {
      marginBottom: '1.5rem',
      color: '#555555'
    },
    serviceFeatures: {
      marginBottom: '1.5rem'
    },
    featureItem: {
      position: 'relative',
      paddingLeft: '1.5rem',
      marginBottom: '0.5rem',
      ':before': {
        content: '"•"',
        position: 'absolute',
        left: '0',
        color: '#000000',
        fontWeight: 'bold'
      }
    },
    pricing: {
      fontWeight: '600',
      color: '#000000',
      marginTop: '1rem'
    }
  };

  const servicesData = [
    {
      id: 1,
      title: "تطوير تطبيقات الويب",
      icon: "💻",
      description: "تصميم وتطوير تطبيقات ويب متكاملة وسريعة باستخدام أحدث التقنيات.",
      features: [
        "تطبيقات أحادية الصفحة (SPA) بتجربة مستخدم ممتازة",
        "واجهات مستخدم تفاعلية وسريعة الاستجابة",
        "تكامل مع واجهات برمجة التطبيقات (APIs)",
        "تحسين أداء التطبيقات",
        "حلول آمنة وقابلة للتطوير"
      ],
      pricing: "تبدأ من 5,000 ريال سعودي"
    },
    {
      id: 2,
      title: "تطوير تطبيقات الهاتف",
      icon: "📱",
      description: "بناء تطبيقات هجينة عالية الجودة تعمل على iOS وAndroid.",
      features: [
        "تطوير باستخدام React Native للجودة والكفاءة",
        "تكامل مع مميزات الهاتف (الكاميرا، GPS، إلخ)",
        "واجهات مستخدم مخصصة",
        "اختبار على أجهزة متعددة",
        "نشر على متاجر التطبيقات"
      ],
      pricing: "تبدأ من 8,000 ريال سعودي"
    },
    {
      id: 3,
      title: "تصميم واجهات المستخدم",
      icon: "🎨",
      description: "تصميم واجهات مستخدم جذابة وسهلة الاستخدام.",
      features: [
        "تصميم وفق معايير UX/UI الحديثة",
        "نماذج أولية تفاعلية (Prototypes)",
        "اختبار قابلية الاستخدام",
        "تطبيق هوية بصرية متسقة",
        "تصميم متجاوب لجميع الشاشات"
      ],
      pricing: "تبدأ من 3,500 ريال سعودي"
    },
    {
      id: 4,
      title: "تطوير واجهات برمجة التطبيقات",
      icon: "🔌",
      description: "بناء واجهات برمجة تطبيقات (APIs) آمنة وقوية.",
      features: [
        "تطوير باستخدام Node.js أو Python",
        "توثيق متكامل للواجهة",
        "نظام مصادقة آمن",
        "اختبارات شاملة",
        "بنية قابلة للتطوير"
      ],
      pricing: "تبدأ من 4,500 ريال سعودي"
    },
    {
      id: 5,
      title: "استشارات تقنية",
      icon: "📊",
      description: "تقديم استشارات متخصصة في مجال تطوير البرمجيات.",
      features: [
        "تحليل احتياجات المشروع",
        "اقتراح الحلول التقنية المناسبة",
        "تقييم البنية التحتية الحالية",
        "تخطيط مسار التطوير",
        "مراجعة الأكواد وتحسين الأداء"
      ],
      pricing: "تبدأ من 300 ريال سعودي/ساعة"
    },
    {
      id: 6,
      title: "صيانة وتحديث المواقع",
      icon: "🛠️",
      description: "صيانة دورية وتحديثات للمواقع والتطبيقات القائمة.",
      features: [
        "إصلاح الأخطاء الفنية",
        "تحديثات أمنية",
        "تحسين أداء التطبيق",
        "إضافة ميزات جديدة",
        "دعم فني مستمر"
      ],
      pricing: "تبدأ من 2,000 ريال سعودي/شهر"
    }
  ];

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <header style={styles.header}>
          <h1 style={styles.title}>خدماتي</h1>
          <p style={styles.subtitle}>حلول تقنية متكاملة تلبي احتياجات عملك</p>
        </header>

        <div style={styles.servicesGrid}>
          {servicesData.map((service) => (
            <div key={service.id} style={styles.serviceCard}>
              <div style={styles.serviceIcon}>{service.icon}</div>
              <h3 style={styles.serviceTitle}>{service.title}</h3>
              <p style={styles.serviceDescription}>{service.description}</p>
              
              <div style={styles.serviceFeatures}>
                {service.features.map((feature, index) => (
                  <p key={index} style={styles.featureItem}>{feature}</p>
                ))}
              </div>
              
              <p style={styles.pricing}>{service.pricing}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;